function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon_clock");

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 19,
  fill: "#e5daca"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 20,
  fill: "none",
  stroke: "#5cb3b1",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 2
});

var _ref6 = /*#__PURE__*/React.createElement("text", null);

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 31,
  y: 15,
  width: 2,
  height: 16,
  rx: 1
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 33,
  y: 31,
  width: 10,
  height: 2,
  rx: 1
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 16.5,
  r: 0.75
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 41.5,
  cy: 16.5,
  r: 0.75
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 23.5,
  r: 0.75
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 23.5,
  r: 0.75
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 40.5,
  r: 0.75
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 47,
  r: 0.75
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 40.5,
  r: 0.75
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 47,
  r: 0.75
});

var _ref17 = /*#__PURE__*/React.createElement("text", null);

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 13.8,
  r: 0.75
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 32,
  r: 0.75
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 32,
  r: 0.75
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 50,
  r: 0.75
});

var SvgIconClock = function SvgIconClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-clock.17c9ff6c.svg";
export { ForwardRef as ReactComponent };